/** As long as the name column allows, so a long filename cannot be refused. */
const MAX = 120;

const FALLBACK = "Untitled recording";

/**
 * A project's name, read off the recording it was made from.
 *
 * The form used to ask for this, with the filename pre-filled into the box —
 * which is a question whose answer is already in the room. A recording arrives
 * already called something, because the tool that made it named it, and the
 * name is editable in the editor afterwards for the times that name is wrong.
 *
 * Only the last extension goes: a screen recorder writes the time into the
 * filename, and "5.36.42 PM" is not three extensions.
 */
export function projectNameFromFile(filename: string): string {
  const named = filename
    .replace(/\.[^.]+$/, "")
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (named.length === 0) return FALLBACK;
  return named.length > MAX ? named.slice(0, MAX).trimEnd() : named;
}
